import { useState, useEffect } from 'react';
import * as THREE from 'three';
import { textureCache } from './useMediaLoader';

export function useTexture(
  material: THREE.ShaderMaterial | null,
  textureUrl: string
) {
  const [dimensions, setDimensions] = useState<[number, number]>([1, 1]);

  useEffect(() => {
    if (!material || !textureUrl) return;

    const texture = textureCache.get(textureUrl);
    if (texture && material.uniforms) {
      material.uniforms.tDiffuse.value = texture;
      material.needsUpdate = true;
      setDimensions([texture.image.width, texture.image.height]);
    }
  }, [textureUrl, material]);

  return dimensions;
}

// Fonction de nettoyage du cache (à appeler lors du démontage de l'application si nécessaire)
export function clearTextureCache() {
  textureCache.forEach(texture => texture.dispose());
  textureCache.clear();
}
